import React from 'react';
import { useEventContext } from '../../context/EventProvider';

const Privacy = () => {
  const { event: { privacyText, privacyLink} } = useEventContext();
  return (
   <div className="privacy-policy-wrapper">
   <a href={privacyLink} target="_blank" className="privacy-policy">{privacyText}</a>
 </div>
  )
}

export default Privacy